// Import level components
// Letters
import LetterHunt from "../components/letters/LetterHunt.vue";
import CatchTheLetter from "../components/letters/CatchTheLetter.vue";
import StrikeTheLetter from "../components/letters/StrikeTheLetter.vue";
import MatchTheLetters from "../components/letters/MatchTheLetters.vue";
import OrderTheLetters from "../components/letters/OrderTheLetters.vue";

// Numbers
import CountingGame from "../components/numbers/CountingGame.vue";

// Words
import WordReading from "../components/words/WordReading.vue";
import WordUnscramble from "../components/words/WordUnscramble.vue";
import AnimalJourney from "../components/words/AnimalJourney.vue";
import WordHunt from "../components/words/WordHunt.vue";

// Colors
import PopBalloon from "../components/colors/PopBalloon.vue";
import ClassificationGame from "../components/colors/ClassificationGame.vue";
import ColoringGame from "../components/colors/ColoringGame.vue";
import ColorMatch from "../components/colors/ColorMatch.vue";
import ColorWheel from "../components/colors/ColorWheel.vue";

// Shapes
import ShapeArrange from "../components/shapes/ShapeArrange.vue";
import FindTheShape from "../components/shapes/FindTheShape.vue";
import StrikeTheShape from "../components/shapes/StrikeTheShape.vue";
import ShapeGathering from "../components/shapes/ShapeGathering.vue";
import ShapeBuilder from "../components/shapes/ShapeBuilder.vue";

// Animals
import AnimalHunt from "../components/animals/AnimalHunt.vue";
import AnimalsHome from "../components/animals/AnimalsHome.vue";
import FeedTheAnimal from "../components/animals/FeedTheAnimal.vue";
import AnimalPuzzle from "../components/animals/AnimalPuzzle.vue";

// Fruits and Vegetables
import FoodGathering from "../components/fruits-and-vegetables/FoodGathering.vue";
import MealGame from "../components/fruits-and-vegetables/MealGame.vue";
import FruitsPicking from "../components/fruits-and-vegetables/FruitsPicking.vue";

// Body
import TapTheBodyPart from "../components/body/TapTheBodyPart.vue";
import MatchTheBodyPart from "../components/body/MatchTheBodyPart.vue";
import BodyFunctions from "../components/body/BodyFunctions.vue";

// Planets
import FindThePlanet from "../components/planets/FindThePlanet.vue";
import PlanetsOrder from "../components/planets/PlanetsOrder.vue";
import AstronautGame from "../components/planets/AstronautGame.vue";
import PlanetariumGame from "../components/planets/PlanetariumGame.vue";

//Professions
import ProfessionMatching from "../components/professions/ProfessionMatching.vue";
import WhoAmI from "../components/professions/WhoAmI.vue";
import WorkplaceMatch from "../components/professions/WorkplaceMatch.vue";
import TaskRunner from "../components/professions/TaskRunner.vue";
import CareerDay from "../components/professions/CareerDay.vue";


// Songs and Stories
import VideoPlayer from "@/components/video-player/VideoPlayer.vue";

// Import images for categories
import VocabllyLettersImage from "@/assets/home/Letters.png";
import VocabllyNumbersImage from "@/assets/home/Numbers.png";
import VocabllyWordsImage from "@/assets/home/Words.png";
import VocabllyColorsImage from "@/assets/home/Colors.png";
import VocabllyShapesImage from "@/assets/home/Shapes.png";
import VocabllyAnimalsImage from "@/assets/home/Animals.png";
import VocabllyFruitsImage from "@/assets/home/Fruits.png";
import VocabllyBodyImage from "@/assets/home/Body.png";
import VocabllyPlanetsImage from "@/assets/home/Planets.png";
import VocabllyProfessionsImage from "@/assets/home/Professions.png";

// Import images for Letters
import LetterHuntImage from "@/assets/letters/letter-hunt.png";
import CatchTheLetterImage from "@/assets/letters/catch-the-letter.png";
import StrikeTheLetterImage from "@/assets/letters/strike-the-vowel.png";
import MatchTheLettersImage from "@/assets/letters/match-letters.png";
import OrderTheLettersImage from "@/assets/letters/order-letters.png";

// Numbers
import OrderNumbersImage from "@/assets/numbers/order-numbers.png";
import NumberHuntImage from "@/assets/numbers/number-hunt.png";
import CatchTheNumberImage from "@/assets/numbers/catch-the-number.png";
import MatchTheNumbersImage from "@/assets/numbers/match-the-numbers.png";
import CountingGameImage from "@/assets/numbers/lets-count.png";

// Shapes
import ShapeArrangeImage from "@/assets/shapes/shape-arrange.png";
import FindTheShapeImage from "@/assets/shapes/find-the-shape.png";
import StrikeTheShapeImage from "@/assets/shapes/strike-the-shape.png";
import ShapeGatheringImage from "@/assets/shapes/shape-gathering.png";
import ShapeBuilderImage from "@/assets/shapes/shape-builder.png";

// Colors
import PopBalloonImage from "@/assets/colors/find-the-color.png";
import ClassificationGameImage from "@/assets/colors/color-picking.png";
import ColoringGameImage from "@/assets/colors/coloring-game.png";
import ColorMatchImage from "@/assets/colors/match-color.png";
import ColorWheelImage from "@/assets/colors/color-wheel.png";

// Words
import WordReadingImage from "@/assets/words/word-reading.png";
import WordUnscrambleImage from "@/assets/words/word-unscramble.png";
import WordHuntImage from "@/assets/words/find-the-word.png";
import AnimalJourneyImage from "@/assets/words/help-the-animals.png";
import MatchTheWordsImage from "@/assets/words/match-the-words.png";

// Animals
import AnimalHuntImage from "@/assets/animals/find-the-animal.png";
import AnimalsHomeImage from "@/assets/animals/animals-home.png";
import FeedTheAnimalImage from "@/assets/animals/feed-the-animal.png";
import AnimalPuzzleImage from "@/assets/animals/animal-puzzle.png";
import MatchTheAnimalsImage from "@/assets/animals/match-the-animals.png";

// Fruits and Vegetables
import FoodGatheringImage from "@/assets/fruits-and-vegetables/drop-the-fruits.png";
import MealGameImage from "@/assets/fruits-and-vegetables/fruits-3.png";
import FruitsPickingImage from "@/assets/fruits-and-vegetables/fruit-picking.png";
import FruitUnscrambleImage from "@/assets/fruits-and-vegetables/fruit-unscramble.png";
import StrikeTheFruitsImage from "@/assets/fruits-and-vegetables/strike-the-fruits.png";

// Body
import TapTheBodyPartImage from "@/assets/body/body-1.png";
import MatchTheBodyPartImage from "@/assets/body/body-2.png";
import BodyPuzzleImage from "@/assets/body/body-puzzle.png";
import BodyFunctionsImage from "@/assets/body/body-functions.png";
import MemoryBodyPartsImage from "@/assets/body/match-body-parts.png";

// Planets
import FindThePlanetImage from "@/assets/planets/planets-1.png";
import PlanetsOrderImage from "@/assets/planets/planets-3.png";
import AstronautGameImage from "@/assets/planets/astronaut-game.png";
import PlanetsPuzzleImage from "@/assets/planets/planets-puzzle.png";
import PlanetariumGameImage from "@/assets/planets/planets-4.png";

// Professions
import ProfessionsGameImage from "@/assets/professions/professions-game.png";
import WhoAmIImage from "@/assets/professions/who-am-i.png";
import WorkplaceGameImage from "@/assets/professions/workplace-game.png";
import TaskGameImage from "@/assets/professions/task-game.png";
import CareerDayImage from "@/assets/professions/career-day.png";

// Export categories
export const categories = [
  {
    name: "letters",
    title: "Letters",
    image: VocabllyLettersImage,
    levels: [
      {
        index: 1,
        title: "Letter Hunt",
        image: LetterHuntImage,
        component: LetterHunt,
      },
      {
        index: 2,
        title: "Catch the Letter",
        image: CatchTheLetterImage,
        component: CatchTheLetter,
      },
      {
        index: 3,
        title: "Strike the Vowel",
        image: StrikeTheLetterImage,
        component: StrikeTheLetter,
      },
      {
        index: 4,
        title: "Match Letters",
        image: MatchTheLettersImage,
        component: MatchTheLetters,
      },
      {
        index: 5,
        title: "Order Letters",
        image: OrderTheLettersImage,
        component: OrderTheLetters,
      },
    ],
  },
  {
    name: "numbers",
    title: "Numbers",
    image: VocabllyNumbersImage,
    levels: [
      {
        index: 1,
        title: "Order the Numbers",
        image: OrderNumbersImage,
        component: OrderTheLetters,
        props: { selectedCategory: "numbers", difficulty: 1 },
      },
      {
        index: 2,
        title: "Number Hunt",
        image: NumberHuntImage,
        component: LetterHunt,
        props: { selectedCategory: "numbers" },
      },
      {
        index: 3,
        title: "Catch the Number",
        image: CatchTheNumberImage,
        component: CatchTheLetter,
        props: { selectedCategory: "numbers" },
      },
      {
        index: 4,
        title: "Counting Game",
        image: CountingGameImage,
        component: CountingGame,
      },
      {
        index: 5,
        title: "Match the Numbers",
        image: MatchTheNumbersImage,
        component: MatchTheLetters,
        props: { selectedCategory: "numbers" },
      },
    ],
  },
  {
    name: "words",
    title: "Words",
    image: VocabllyWordsImage,
    levels: [
      {
        index: 1,
        title: "Word Reading",
        image: WordReadingImage,
        component: WordReading,
      },
      {
        index: 2,
        title: "Match the Words",
        image: MatchTheWordsImage,
        component: MatchTheLetters,
        props: { selectedCategory: "words" },
      },
      {
        index: 3,
        title: "Word Unscramble",
        image: WordUnscrambleImage,
        component: WordUnscramble,
      },
      {
        index: 4,
        title: "Animal Journey",
        image: AnimalJourneyImage,
        component: AnimalJourney,
      },
      {
        index: 5,
        title: "Word Hunt",
        image: WordHuntImage,
        component: WordHunt,
      },
    ],
  },
  {
    name: "colors",
    title: "Colors",
    image: VocabllyColorsImage,
    levels: [
      {
        index: 1,
        title: "Pop Balloon",
        image: PopBalloonImage,
        component: PopBalloon,
      },
      {
        index: 2,
        title: "Classification Game",
        image: ClassificationGameImage,
        component: ClassificationGame,
      },
      {
        index: 3,
        title: "Coloring Game",
        image: ColoringGameImage,
        component: ColoringGame,
      },
      {
        index: 4,
        title: "Color Match",
        image: ColorMatchImage,
        component: ColorMatch,
      },
      {
        index: 5,
        title: "Color Wheel",
        image: ColorWheelImage,
        component: ColorWheel,
      },
    ],
  },
  {
    name: "shapes",
    title: "Shapes",
    image: VocabllyShapesImage,
    levels: [
      {
        index: 1,
        title: "Shape Arrange",
        image: ShapeArrangeImage,
        component: ShapeArrange,
      },
      {
        index: 2,
        title: "Find the Shape",
        image: FindTheShapeImage,
        component: FindTheShape,
      },
      {
        index: 3,
        title: "Strike the Shape",
        image: StrikeTheShapeImage,
        component: StrikeTheShape,
      },
      {
        index: 4,
        title: "Shape Gathering",
        image: ShapeGatheringImage,
        component: ShapeGathering,
      },
      {
        index: 5,
        title: "Shape Builder",
        image: ShapeBuilderImage,
        component: ShapeBuilder,
      },
    ],
  },
  {
    name: "animals",
    title: "Animals",
    image: VocabllyAnimalsImage,
    levels: [
      {
        index: 1,
        title: "Animal Hunt",
        image: AnimalHuntImage,
        component: AnimalHunt,
      },
      {
        index: 2,
        title: "Match the Animals",
        image: MatchTheAnimalsImage,
        component: MatchTheLetters,
        props: { selectedCategory: "animals" },
      },
      {
        index: 3,
        title: "Animals Home",
        image: AnimalsHomeImage,
        component: AnimalsHome,
      },
      {
        index: 4,
        title: "Feed the Animal",
        image: FeedTheAnimalImage,
        component: FeedTheAnimal,
      },
      {
        index: 5,
        title: "Animal Puzzle",
        image: AnimalPuzzleImage,
        component: AnimalPuzzle,
      },
    ],
  },
  {
    name: "fruits-and-veggies",
    title: "Fruits and Vegetables",
    image: VocabllyFruitsImage,
    levels: [
      {
        index: 1,
        title: "Strike the Fruit",
        image: StrikeTheFruitsImage,
        component: StrikeTheLetter,
        props: { selectedCategory: "fruitsAndVeggies" },
      },
      {
        index: 2,
        title: "Food Gathering",
        image: FoodGatheringImage,
        component: FoodGathering,
      },
      {
        index: 3,
        title: "Meal Game",
        image: MealGameImage,
        component: MealGame,
      },
      {
        index: 4,
        title: "Fruit Unscramble",
        image: FruitUnscrambleImage,
        component: WordUnscramble,
        props: { mode: "fruits" },
      },
      {
        index: 5,
        title: "Fruits Picking",
        image: FruitsPickingImage,
        component: FruitsPicking,
      },
    ],
  },
  {
    name: "body",
    title: "Body",
    image: VocabllyBodyImage,
    levels: [
      {
        index: 1,
        title: "Tap the Body Part",
        image: TapTheBodyPartImage,
        component: TapTheBodyPart,
      },
      {
        index: 2,
        title: "Body Puzzle",
        image: BodyPuzzleImage,
        component: AnimalPuzzle,
        props: { mode: "body" },
      },
      {
        index: 3,
        title: "Match the Body Part",
        image: MatchTheBodyPartImage,
        component: MatchTheBodyPart,
      },
      {
        index: 4,
        title: "Body Functions",
        image: BodyFunctionsImage,
        component: BodyFunctions,
      },
      {
        index: 5,
        title: "Memory Body Parts",
        image: MemoryBodyPartsImage,
        component: MatchTheLetters,
        props: { selectedCategory: "body" },
      },
    ],
  },
  {
    name: "planets",
    title: "Solar System",
    image: VocabllyPlanetsImage,
    levels: [
      {
        index: 1,
        title: "Find the Planet",
        image: FindThePlanetImage,
        component: FindThePlanet,
      },
      {
        index: 2,
        title: "Planets Order",
        image: PlanetsOrderImage,
        component: PlanetsOrder,
      },
      {
        index: 3,
        title: "Astronaut Game",
        image: AstronautGameImage,
        component: AstronautGame,
      },
      {
        index: 4,
        title: "Planets Puzzle",
        image: PlanetsPuzzleImage,
        component: AnimalPuzzle,
        props: { mode: "planets" },
      },
      {
        index: 5,
        title: "Planetarium Game",
        image: PlanetariumGameImage,
        component: PlanetariumGame,
      },
    ],
  },
  {
    name: "professions",
    title: "Professions",
    image: VocabllyProfessionsImage,
    levels: [
      {
        index: 1,
        title: "Professions",
        image: ProfessionsGameImage,
        component: ProfessionMatching,
      },
      {
        index: 2,
        title: "Who Am I?",
        image: WhoAmIImage,
        component: WhoAmI,
      },
      {
        index: 3,
        title: "Workplace",
        image: WorkplaceGameImage,
        component: WorkplaceMatch,
      },
      {
        index: 4,
        title: "Task Runner",
        image: TaskGameImage,
        component: TaskRunner,
      },
      {
        index: 5,
        title: "Career Day",
        image: CareerDayImage,
        component: CareerDay,
      },
    ],
  },
  /*
  {
    name: "time",
    title: "Time",
    image: VocabllyProfessionsImage,
    levels: [
      {
        index: 1,
        title: "Time of the Day",
        image: ProfessionsGameImage,
        component: TimeOfTheDay,
      },
      {
        index: 2,
        title: "Day of the Week",
        image: WhoAmIImage,
        component: DayOfTheWeek,
      },
      {
        index: 3,
        title: "Seasons Game",
        image: WorkplaceGameImage,
        component: MonthsSeasonsGame,
      },
      {
        index: 4,
        title: "Hours In English",
        image: WorkplaceGameImage,
        component: HoursInEnglish,
      }
    ],
  },
  */
  {
    name: "songs-and-stories",
    title: "Songs and Stories",
    image: WordReadingImage,
    levels: [
      {
        index: 1,
        title: "Vowels Song",
        image: MatchTheLettersImage,
        component: VideoPlayer,
        props: {
          src: "/videos/vowels-song.mp4",
          title: "Vowels Song",
        },
      },
      {
        index: 2,
        title: "Alphabet Song",
        image: VocabllyLettersImage,
        component: VideoPlayer,
        props: {
          src: "/videos/alphabet-song.mp4",
          title: "Alphabet Song",
        },
      },
      {
        index: 3,
        title: "Numbers Song",
        image: OrderNumbersImage,
        component: VideoPlayer,
        props: {
          src: "/videos/numbers-song.mp4",
          title: "Numbers Song",
        },
      },
      {
        index: 4,
        title: "The Vowel Adventure",
        image: OrderTheLettersImage,
        component: VideoPlayer,
        props: {
          src: "/videos/the-vowel-adventure.mp4",
          title: "The Vowel Adventure",
        },
      },
    ],
  },
];